<template>
  <div class="width-100 mainBox flex-column justify-content-start align-items-center" style="min-width: 1200px">
    <!--    顶部菜单栏-->
    <tab class="fixed" selectTab="3" style="min-width: 1200px"></tab>

    <img src="@/assets/image/banner2.jpg" width="100%" alt="" />
    <div
      class="main flex-row justify-content-spaceBetween align-items-center margin-ts"
      style="border-bottom: 1px solid #eeeeee; padding-bottom: 20px"
    >
      <p class="fs-mid grey margin-bs">当前位置：首页 > 通知公告</p>
      <search-box></search-box>
    </div>
    <div class="main flex-row justify-content-spaceBetween align-items-star">
      <div class="width-100">
        <div
          @mouseenter="addClassload(index)"
          @mouseleave="removeClassload()"
          :class="{ 'bg-slightGrey': classenable && current === index }"
          @click="newsDetail(item.id)"
          v-for="(item, index) in Notice"
          :key="index"
          class="width-100 pointer border-b select flex-row justify-content-around align-items-star"
        >
          <div class="box flex-column justify-content-spaceBetween align-items-star">
            <div class="width-100 margin-bs">
              <p class="fs-big fw-mid margin-bs cutText">{{ item.title }}</p>
              <p class="fs-mid lineHeight1 cutText3">{{ item.summary }}</p>
            </div>
            <p class="fs-sml width-100 textAlign-l grey">
              <van-icon color="#cccccc" class="margin-rs" name="clock" />
              {{ item.createTime.substring(0, 10) }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <van-pagination @change="mountedData" class="margin-ts" v-model="currentPage" :total-items="total" :items-per-page="10" :show-page-size="10">
      <template #prev-text>
        <van-icon name="arrow-left" />
      </template>
      <template #next-text>
        <van-icon name="arrow" />
      </template>
      <template #page="{ text }">{{ text }}</template>
    </van-pagination>
    <backBtn></backBtn>

    <footerBox class="margin-t footer"></footerBox>
  </div>
</template>
<script>
import tab from '@/components/tab.vue';
import footerBox from '@/components/footer.vue';
import backBtn from '@/components/backBtn.vue';
import newsApi from '@/api/newsApi';
import SearchBox from '@/components/searchBox';
import PubSub from 'pubsub-js';
export default {
  name: 'notice',
  components: {
    SearchBox,
    tab,
    footerBox,
    backBtn
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      tabIndex: 0,
      classenable: false,
      current: 0,
      total: 0,
      Notice: [],
      searchText: null,
      tabList: [
        {
          index: 0,
          text: '集团动态'
        },
        {
          index: 1,
          text: '辖属动态'
        },
        {
          index: 2,
          text: '媒体报道'
        },
        {
          index: 4,
          text: '党群活动'
        }
      ]
    };
  },
  mounted() {},

  created() {
    PubSub.subscribe('searchBoxText', (msg, data) => {
      console.log(msg + ', ' + data);
      this.searchText = data;
      this.mountedData();
    });
    this.mountedData();
  },
  methods: {
    mountedData() {
      newsApi
        .list({ status: '1', params: { pageNum: this.currentPage, pageSize: this.pageSize, likeType: '001' } })
        .then((res) => {
          this.total = res.total;
          this.Notice = res.rows;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    select(e) {
      this.tabIndex = e;
    },
    jumpTo(e, m) {
      this.$router.push({ path: e, params: { Id: m } });
    },
    newsDetail(id) {
      let text = this.$router.resolve({ path: '/newsDetail', query: { type: 'notice', newsId: id } });
      // 打开一个新的页面
      window.open(text.href, '_blank');
    },
    addClassload(e) {
      this.classenable = true;
      this.current = e;
    },
    removeClassload() {
      this.classenable = false;
      // this.current=index;
    }
  }
};
</script>

<style lang="less" scoped>
.fixed {
  position: fixed;
  top: 0;
  z-index: 99;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}

.mainBox {
  height: 200px;
  padding-top: 60px;
}

.search {
  border: none !important;
}

.searchBox {
  padding: 4px 10px;
  border-radius: 5px;
}

.tab {
  height: 50px;
  width: 100%;
  line-height: 50px;
  text-align: center;
  border-bottom: 1px solid #eeeeee;
}

.tab_avtive {
  background: rgb(11, 73, 158) !important;
  border-left: 6px solid rgb(204, 58, 58);
  color: white;
  border-bottom: none;
}

.border-b {
  border-bottom: 1px solid #eeeeee;
}

.box {
  max-height: 140px;
  padding: 20px 3%;
  width: 94%;
}

.leftBox {
  width: 17%;
  margin-right: 3%;
}
.footer {
}
</style>
<style>
.van-pagination__item--active {
  background-color: rgb(11, 73, 158) !important;
  color: #ffffff !important;
}

.van-pagination__item {
  min-width: 30px;
  height: 30px;
  margin: 0 3px;
  border: 1px solid #eeeeee;
  color: #666666;
}
</style>
